import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Haldor__Block__Plugin } from '@haldor/ui';
import { ASSESSMENT_TYPES } from '../AssessmentTypes';

var PushAssessmentBlock_Plugin = /*#__PURE__*/function (_Haldor__Block__Plugi) {
  _inherits(PushAssessmentBlock_Plugin, _Haldor__Block__Plugi);

  var _super = _createSuper(PushAssessmentBlock_Plugin);

  function PushAssessmentBlock_Plugin(props) {
    var _this;

    _classCallCheck(this, PushAssessmentBlock_Plugin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "editorMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _assertThisInitialize, editor;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _assertThisInitialize = _assertThisInitialized(_this), editor = _assertThisInitialize.editor;

              if (!(editor.getBlocks().length == 0)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return editor.addBlock('Haldor.Blocks.AssessmentBlock');

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.name = 'PushAssessmentBlock_Plugin';
    return _this;
  }

  return _createClass(PushAssessmentBlock_Plugin);
}(Haldor__Block__Plugin);

export default PushAssessmentBlock_Plugin;